import type { Operation } from '@/services/types'
import type { PaginationUrlFilterScalarValueType } from '@/services/tables/types'

export const getFullFilledOperations = (filterValue: PaginationUrlFilterScalarValueType) => {
  return Object.keys(filterValue).filter((key) => {
    if (filterValue[key] === undefined || filterValue[key] === null) {
      return false
    }
    if (Array.isArray(filterValue[key]) && filterValue[key].length === 0) {
      return false
    }
    return true
  }) as Operation[]
}
